import { useState } from 'react'

import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { Button, CircularProgress } from '@mui/material'
import { format } from 'date-fns'
import { toast } from 'react-toastify'

import { useGetBidNegotiationExportRowsLazyQuery } from 'generated/graphql'
import { downloadCsv, toCsv } from 'helpers/csv.helpers'

import { useNegotiationOverviewQueryInput } from './useNegotiationOverviewQueryInput'

export const NegotiationOverviewExportButton = () => {
  const { hasValidRange, input } = useNegotiationOverviewQueryInput()
  const [isExporting, setIsExporting] = useState(false)
  const [fetchExportRows] = useGetBidNegotiationExportRowsLazyQuery()

  const handleExportCsv = async () => {
    setIsExporting(true)

    try {
      const { data } = await fetchExportRows({ variables: { input } })
      const rows = data?.bidNegotiationExportRows ?? []

      if (rows.length === 0) {
        toast.info('There is nothing to export for the selected filters.')
        return
      }

      const csv = toCsv(
        [
          'Booking ID',
          'Reference',
          'Service code',
          'Vehicle type',
          'Posted date',
          'Supplier',
          'Negotiated',
          'Original bid',
          'Final bid',
          'Currency',
          'Delta amount',
          'Delta %',
        ],
        rows.map((row) => [
          row.bookingId,
          row.reference,
          row.serviceCode,
          row.vehicleType,
          format(new Date(row.postedDate), 'yyyy-MM-dd'),
          row.supplierName,
          row.wasNegotiated ? 'Yes' : 'No',
          row.originalPrice,
          row.finalPrice,
          row.currencyCode,
          row.deltaAmount,
          row.deltaPercentage,
        ]),
      )

      downloadCsv(csv, `negotiation_overview_${format(new Date(), 'yyyyMMdd')}.csv`)
    } catch {
      toast.error('Could not export the negotiation overview.')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <Button
      variant='outlined'
      size='medium'
      startIcon={
        isExporting ? <CircularProgress size={16} /> : <FileDownloadOutlinedIcon fontSize='small' />
      }
      disabled={!hasValidRange || isExporting}
      onClick={handleExportCsv}
      sx={{ whiteSpace: 'nowrap', flexShrink: 0, height: 40 }}>
      Export CSV
    </Button>
  )
}
